import React from 'react'
import { useSelector } from 'react-redux'
import { KibChevronDownIcon, KibChevronUpIcon } from '@chewy/kib-icons-react'

import RhapTextButton from '~/components/common/RhapTextButton'
import FeatureToggle from '~/constants/featureToggle'
import { getFeatureToggle } from '~/store/reducers/constants'

import styles from './SortingFilter.module.scss'

export interface SortingFilterProps {
  isAscending?: boolean
  label: string
  onSort: (ascending: boolean) => void
}

const SortingFilter = ({ label, isAscending, onSort }: SortingFilterProps) => {
  const isInventoryKibFiltersEnabled = useSelector(
    getFeatureToggle(FeatureToggle.INVENTORY_KIB_FILTERS),
  )

  if (!isInventoryKibFiltersEnabled) {
    return null
  }

  return (
    <RhapTextButton
      plainHover
      className={styles.sortingButton}
      icon={isAscending ? <KibChevronUpIcon /> : <KibChevronDownIcon />}
      iconPosition="end"
      onClick={() => onSort(!isAscending)}
    >
      {label}
    </RhapTextButton>
  )
}

export default SortingFilter
